import React, { useEffect, useState, useCallback } from "react";
import { Box, Grid, TextField, Typography, Button } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { InfoOutlined as InfoIcon, Save as SaveIcon } from "@material-ui/icons";
import SettingsService from "../../../services/SettingsService";

const Texts = () => {
  const [homeText, setHomeText] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [saving, setSaving] = useState(false);
  const loadHomeText = useCallback(async () => {
    setFeedback(null);

    try {
      const response = await SettingsService.getHomeText();
      setHomeText(response || "");
    } catch (error) {
      console.error("Erro ao carregar texto da home:", error);
      setFeedback({
        type: "error",
        message:
          "Não foi possível carregar o texto da home. Tente novamente mais tarde."
      });
    }
  }, []);

  useEffect(() => {
    loadHomeText();
  }, [loadHomeText]);

  const saveHomeText = useCallback(async () => {
    setSaving(true);
    setFeedback(null);

    try {
      await SettingsService.setHomeText({ value: homeText });
      setFeedback({
        type: "success",
        message: "Texto da home salvo com sucesso."
      });
    } catch (error) {
      console.error("Erro ao salvar texto da home:", error);
      setFeedback({
        type: "error",
        message:
          "Não foi possível salvar o texto da home. Tente novamente mais tarde."
      });
    } finally {
      setSaving(false);
    }
  }, [homeText]);

  return (
    <Box p={3}>
      {feedback && (
        <Box mb={2}>
          <Alert severity={feedback.type}>{feedback.message}</Alert>
        </Box>
      )}
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" mb={1}>
          <Box display="flex" alignItems="center">
            <Typography variant="subtitle1" style={{ marginBottom: 0 }}>
              Texto da Home
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              value={homeText}
              onChange={event => setHomeText(event.target.value)}
              variant="outlined"
              fullWidth
              multiline
              minRows={10}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              height="100%"
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <Alert severity="info" icon={<InfoIcon fontSize="small" />}>
                Esse texto aparece no banner do Painel de Adesão e é exibido
                para todos os usuários logo após o login. Utilize esse espaço
                para orientações ou mensagens institucionais curtas.
                <br />
                Se você deixar o campo vazio, será exibida a mensagem padrão:
                &quot;Bem-vindo(a) à Central de Comunicados! Envie comunicados,
                e-mails e mensagens.&quot;
              </Alert>
              <Box mt={2} display="flex" justifyContent="center">
                <img
                  src="https://storage.googleapis.com/waybee-production/assets/home_text_settings_info.png"
                  alt="Ilustração do texto da home"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={saveHomeText}
              disabled={saving}
              startIcon={<SaveIcon />}
            >
              {saving ? "Salvando..." : "Salvar"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Texts;
